export enum CalculationTypes {
  runningCost = 'RUNNING_COST',
  resaleValue = 'RESALE_VALUE',
}

export const tabItems = [
  {
    name: 'Overview',
    value: 1,
    link: '',
  },
  {
    name: 'Review',
    value: 2,
    link: 'review',
  },
  {
    name: 'Price',
    value: 3,
    link: 'price',
  },
  // {
  //   name: 'Compare',
  //   value: 4,
  //   link: 'compare',
  // },
  {
    name: 'Images',
    value: 5,
    link: 'images',
  },
  {
    name: 'Specification',
    value: 6,
    link: 'specification',
  },
  {
    name: 'Variants',
    value: 7,
    link: 'variants',
  },
  {
    name: 'Colour',
    value: 8,
    link: 'colour',
  },
  {
    name: 'Mileage',
    value: 9,
    link: 'mileage',
  },
];
